import React, { useState, useEffect, useCallback, memo, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Collapse, CircularProgress, Divider, TextField, Grid } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import {
  ExpandLessRounded as UpIcon,
  ExpandMoreRounded as DownIcon,
  EditRounded as EditIcon,
  CloseRounded as CloseIcon,
  FindInPageRounded as InfoIcon,
  ChevronRight,
} from '@material-ui/icons'
import * as dateFns from 'date-fns';
import api from '../../../services/api'
import messsages from '../../../services/messages';

import { isArray, objLength } from '../../../utils/customMethods'

import { setUsability } from '../../../redux/usability/actions'
import {
  getWidgets,
  setWidgets,
  getWidget,
  setWidget,
  widgetsError,
} from '../../../redux/widgets/actions'

import { getChatInfo } from '../../../utils/chatInfo'
import { changeDisplayName, setConversations } from '../../../redux/conversations/actions'

import DialogEditName from '../../organisms/dialogs/editName'
import Chip from '../../atoms/display/chip'
import Typography from '../../atoms/display/typography'
import SelectField from '../../atoms/inputs/selectfield'
import Button from '../../atoms/inputs/button'
import IconButton from '../../atoms/inputs/iconButton'
import Demand from '../../organisms/panels/Demand'
import TabList from '../../organisms/panels/TabList'
import EmptyState from '../../atoms/display/emptyState'
import MoleculesSnackbarReload from '../../molecules/snackbar/reload'
import useStyles from './historyDataStyle'
import EscapeDrag from '../../molecules/display/escapeDrag'

const HistoryData = (props) => {
  const undock = useSelector((state) => state.undock)

  const { t } = useTranslation()
  const classes = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()

  const activeConversation = undock.data
    ? undock.activeConversation
    : useSelector((state) => state.activeConversation)

  const conversations = undock.data
    ? undock.conversations
    : useSelector((state) => state.conversations)

  const history = useSelector((state) => state.history)
  const conversation = conversations.conversations[activeConversation]
  const relatedComponents = conversation?.relatedComponents
  const tabs = useSelector((state) => state.tabs)
  const widgets = useSelector((state) => state.widgets)
  const generalInformation = useSelector((state) => state.generalInformation)
  const features = useSelector((state) => state.features)
  const commentary = conversation?.conversationsComments ?? [];
  const [summaryTransfers, setSummaryTransfers] = useState(false);
  const [summaryTransfersLoading, setSummaryTransfersLoading] = useState(false);  

  const formateDateTime = useCallback((dateString)=>{
    try {  
      let date = new Date(`${dateString}`);
      date = dateFns.format(date,'dd/MM/yyyy HH:mm');
      date = date.split(' ');
      date = `${date[0]} - ${date[1]}`;
      return date;
    } catch (error) {
      return error?.message;
    }
  },[]);

  const getConversations = () => {
    setSummaryTransfersLoading(true);
    
    messsages.get(`tech4h-messages/conversations/${conversation?.conversationId}/comments` )
    .then((response)=>{
      dispatch(setConversations({
        ...conversation,
        conversationsComments: response.data?.data ?? [],
      }))
    }).catch((erro)=>{

    }).finally(()=>{
      setSummaryTransfersLoading(false);
    })   
  }

  const summaryTransfersToggle = useCallback(async ()=>{
   
    setSummaryTransfers((old)=> {
      if(!old && commentary?.length == 0){
        getConversations();
      }
      return !old;
    });
  },[summaryTransfersLoading, getConversations, commentary]);
  
  const consumer = useMemo(() => {
    if (props?.isResearched) {
      const chatId = props?.chatId
        ? props.chatId
        : !props?.isHistoryData
        ? activeConversation
        : null

      const userConsumer =
        history?.conversations?.[props?.consumerId]?.[chatId]?.consumer

      if (userConsumer) {
        return userConsumer
      }
    }

    if (undock.data) {
      return undock.conversations[activeConversation]?.consumer
    }

    return conversation?.consumer || {}
  }, [
    activeConversation,
    undock,
    conversation,
    props?.chatId,
    props?.isResearched,
  ])

  const [skillId, setSkillId] = useState(null)
  const [dialogEditName, setDialogEditName] = useState(false)
  const [cleanLoading, setCleanLoading] = useState(false)
  const [expanded, setExpanded] = useState({
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
  })
  const [relation, setRelation] = useState(null)

  // TODO: get this list through API when CRUD is implemented
  const relationList = [
    { _id: 'segurado', name: 'Segurado' },
    { _id: 'corretor', name: 'Corretor' },
    { _id: 'terceiro', name: 'Terceiro' },
    { _id: 'relator', name: 'Relator' },
    {
      _id: 'condutor/motorista',
      name: 'Condutor/Motorista',
    },
    { _id: 'conjuge', name: 'Cônjuge' },
    { _id: 'filho-filha', name: 'Filho/Filha' },
    { _id: 'funcionario', name: 'Funcionário' },
    { _id: 'oficinas', name: 'Oficinas' },
    { _id: 'prestador', name: 'Prestador' },
    { _id: 'irmao-irma', name: 'Irmão/Irmã' },
    { _id: 'pai-mae', name: 'Pai/Mãe' },
    { _id: 'neto-neta', name: 'Neto/Neta' },
    { _id: 'inquilino', name: 'Inquilino' },
    { _id: 'sindicante', name: 'Sindicante' },
  ]

  const updateExtraInfo = (widgetData) => {
    const persistData = async (clientInfo, usability) => {
      if (activeConversation) {
        try {
          const response = await api.patch(
            `/conversation-extra-info?id=${activeConversation}`,
            { clientInfo, usability }
          )
          if (response.status !== 200) throw response.data
        } catch (error) {
          const message =
            error?.response?.data?.message ?? 'Unavailable service'
          console.error(message)
        }
      }
    }

    if (
      conversation.status !== 'closed' &&
      conversation.status !== 'pos-chat'
    ) {
      const availableWidgets = widgets?.conversations?.[props?.chatId]
      const usabilityData =
        widgetData ??
        availableWidgets?.find((el) => el.name === 'Usabilidade')?.data
      const userData = usabilityData?.user_data
      const siebelData = usabilityData?.siebel_data
      const data =
        objLength(userData) > 1
          ? userData
          : objLength(siebelData) > 1
          ? {
              Protocolo: siebelData?.SRNumber,
              Apolice: siebelData?.nrApolice,
              CPF: siebelData?.cpfCnpj,
            }
          : null
      const usability = {
        breadcrumbs: widgetData?.breadcrumbs ?? usabilityData?.breadcrumbs,
        scenario: widgetData?.scenario ?? usabilityData?.scenario,
        relation: relatedComponents.data.identification.relation,
      }
      let clientInfo

      if (data) {
        // convert to obj with only key and value
        clientInfo = sortData(data).reduce((obj, el) => {
          obj[el.key] = el.value
          return obj
        }, {})
      }

      persistData(clientInfo, usability)
    }
  }

  const getDataFromExtraInfo = async (chatId, widgetId, widgetName) => {
    dispatch(getWidget())
    const obj = { chatId, widgetId, widgetName }
    const widgetData =
      generalInformation.conversations[chatId]?.extraInfo ??
      (await getChatInfo(chatId, dispatch)?.extraInfo)

    obj.data = {
      ...widgetData?.usability,
      user_data: widgetData?.clientInfo,
    }
    relatedComponents.data.identification.relation =
      widgetData?.usability?.relation

    dispatch(setWidget(obj))
  }

  const callWidget = async (chatId, widgetId, widgetName) => {
    if (chatId && widgetId) {
      const chatWidgets = widgets?.conversations?.[chatId]
      const haveWidget = chatWidgets?.some(
        (el) => el.id === widgetId && objLength(el.data) > 0
      )

      if (haveWidget) return

      if (
        conversation.status !== 'closed' &&
        conversation.status !== 'pos-chat'
      ) {
        dispatch(getWidget())
        try {
          const response = await api.post(`/widget-data`, {
            widgetId: widgetId,
            conversationId: chatId,
          })

          if (response.status === 200 && objLength(response?.data?.data) > 0) {
            const data = response.data.data
            const obj = { chatId, widgetId, widgetName, data }

            // TODO: remove this line when backend removes message from user_data
            if (data?.user_data?.message) delete data.user_data.message

            dispatch(setWidget(obj))
            updateExtraInfo(obj.data)
          } else {
            throw response.data
          }
        } catch (error) {
          const obj = { chatId, widgetId, widgetName, data: {} }
          const message =
            error?.response?.data?.message ?? 'Unavailable service'

          dispatch(setWidget(obj))
          dispatch(widgetsError({ action: 'get_widget', message: message }))
        }
      } else {
        await getDataFromExtraInfo(chatId, widgetId, widgetName)
      }
    }
  }

  const callWidgets = async (chatId, skillId) => {
    if (!widgets?.status?.get_widgets?.loading && !widgets?.list?.length > 0) {
      dispatch(getWidgets())
      try {
        const response = await api.get(`/user/widgets`)

        if (response.status === 200) {
          const data = response?.data?.data?.widgets
          const usability = data?.find(
            (el) =>
              (el.name === 'Usabilidade' || el.name === 'Link') &&
              el.skill_id === skillId
          )
          dispatch(setWidgets(data))
          await callWidget(chatId, usability?.id, usability?.name, skillId)
        } else {
          throw response.data
        }
      } catch (error) {
        let message = error?.response?.data?.message ?? 'Unavailable service'
        dispatch(widgetsError({ action: 'get_widgets', message: message }))
      }
    } else {
      const usability = widgets?.list?.find(
        (el) =>
          (el.name === 'Usabilidade' || el.name === 'Link') &&
          el.skill_id === skillId
      )

      await callWidget(chatId, usability?.id, usability?.name, skillId)
    }
  }

  const handleCollapse = useCallback((index) => {
    setExpanded((expanded) => ({
      ...expanded,
      [index]: expanded[index] === true ? false : true,
    }))
  }, [])

  const cleanHandle = () => {
    if (activeConversation) {
      setCleanLoading(true)
      api({
        method: 'patch',
        url: `/display-name?id=${consumer.id}`,
        data: {
          display_name: null,
        },
      })
        .then((response) => {
          setCleanLoading(false)
          if (response.status !== 200) {
          } else {
            dispatch(
              changeDisplayName({
                conversationId: activeConversation,
                displayName: null,
              })
            )
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  const handleRelationSelect = useCallback(
    (event) => {
      const option = relationList.find(
        (el) =>
          el._id ===
          (event
            ? event?.target?.value
            : relatedComponents.data.identification.relation)
      )
      relatedComponents.data.identification.relation = option?._id
      setRelation(option)

      option && updateExtraInfo(null)
    },
    [relationList, relatedComponents, setRelation]
  )

  const handleUsabilityClick = (usability) => {
    if (objLength(usability?.data) > 0) {
      let url =
        usability.data.siebel_data?.url_usabilidade ??
        usability.data.protocol_data?.url

      // update url
      if (url && relation?.name) {
        url = url.replace('[RELACIONAMENTO]', relation.name)
        relatedComponents.usability = {
          isOpen: true,
          url: url,
        }

        // TODO: temporary for component update. Improve it in the future
        dispatch(setUsability(Date.now()))
      }
    }
  }

  const renderContactInfo = () => {
    return (
      <>
        <div className={classes.menuBar} onClick={() => handleCollapse(0)}>
          <Typography variant="body1">
            {t('commons.contactIdentification')}
          </Typography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {expanded[0] ? (
              <UpIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            ) : (
              <DownIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            )}
          </div>
        </div>
        <Collapse in={expanded[0]} unmountOnExit>
          <div className={classes.content} style={{ padding: 5 }}>
            <table width="100%" cellPadding="10">
              <tbody>
                <tr>
                  <td width="20%">
                    <Typography variant="body1">
                      {t('commons.name')}:
                    </Typography>
                  </td>
                  <td width="80%">
                    <Typography variant="body1">{consumer?.name}</Typography>
                  </td>
                  {conversation.status !== 'closed' &&
                    conversation.status !== 'pos-chat' &&
                    !consumer?.displayName &&
                    !props?.isResearched && (
                      <td>
                        <IconButton
                          onClick={() => setDialogEditName(true)}
                          style={{ color: theme.palette.primary.main }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </td>
                    )}
                </tr>
                {consumer?.displayName && (
                  <tr>
                    <td width="20%" style={{ whiteSpace: 'nowrap' }}>
                      <Typography variant="body1">
                        {t('commons.editedName')}:
                      </Typography>
                    </td>
                    <td width="80%">
                      <Typography variant="body1">
                        {consumer?.displayName}
                      </Typography>
                    </td>
                    {conversation.status !== 'closed' &&
                      conversation.status !== 'pos-chat' &&
                      !props?.isResearched && (
                        <td style={{ whiteSpace: 'nowrap' }}>
                          <IconButton
                            disabled={cleanLoading}
                            onClick={() => cleanHandle()}
                            style={{ color: theme.palette.primary.main }}
                          >
                            {cleanLoading ? (
                              <CircularProgress size={18} color="primary" />
                            ) : (
                              <CloseIcon fontSize="small" />
                            )}
                          </IconButton>
                          <IconButton
                            onClick={() => setDialogEditName(true)}
                            style={{ color: theme.palette.primary.main }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </td>
                      )}
                  </tr>
                )}
                <tr>
                  <td colSpan="3">
                    <SelectField
                      label={t('fields.relationship.label')}
                      placeholder={t('fields.relationship.placeHolder')}
                      name="relationship"
                      data={relationList}
                      value={relation?._id}
                      onChange={handleRelationSelect}
                      disabled={
                        conversation.status === 'closed' ||
                        conversation.status === 'pos-chat'
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Collapse>
      </>
    )
  }

  const getColor = (el) => {
    const colors = [
      /telefone|cpf|rg|titular|protocolo/gi, // cyan
      /empresa|produto|status|proposta|certificado/gi, // blue
      /ap[oó]lice|placa|endere[cç]o|complemento/gi, // pink
      /valida[cç][aã]o/gi,
    ]

    for (let key = 0; key < colors.length; key++) {
      if (colors[key].test(el[0]))
        return key === 3 ? (/^validado/i.test(el[1]) ? 3 : 4) : key
    }
    return 1
  }

  const sortData = (obj) => {
    let array =
      objLength(obj) > 0
        ? Object.entries(obj).map((el) => ({
            key: el[0],
            value: el[1],
            color: getColor(el),
          }))
        : []

    // sort array
    array.sort((a, b) => (a.color < b.color ? -1 : a.color > b.color ? 1 : 0))

    return array
  }

  const getClientData = (usability) => {
    const userData = usability?.data?.user_data
    const siebelData = usability?.data?.siebel_data
    const data =
      objLength(userData) > 1
        ? userData
        : objLength(siebelData) > 1
        ? {
            Protocolo: siebelData?.SRNumber,
            Apolice: siebelData?.nrApolice,
            CPF: siebelData?.cpfCnpj,
          }
        : {}

    return sortData(data)
  }

  const renderRetryButton = (usability, chatId, skillId) => {
    const retryCall = async () => {
      await callWidget(chatId, usability?.id, usability?.name, skillId)
    }

    return usability && !objLength(usability?.data) > 0 ? (
      <div style={{ padding: 10 }}>
        <MoleculesSnackbarReload
          onClick={retryCall}
          loading={widgets?.status?.get_widget?.loading}
        />
      </div>
    ) : null
  }

  const renderServiceSummary = (usability, chatId) => {
    const data = getClientData(usability)
    return (
      <>
        <div className={classes.menuBar} onClick={() => handleCollapse(1)}>
          <Typography variant="body1">{t('commons.findCustomer')}</Typography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {expanded[1] ? (
              <UpIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            ) : (
              <DownIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            )}
          </div>
        </div>
        <Collapse in={expanded[1]} timeout="auto" unmountOnExit>
          {!usability?.data &&
          (widgets?.status?.get_widgets?.loading ||
            widgets?.status?.get_widget?.loading) ? (
            <div className={classes.loadingSection}>
              <CircularProgress size={25} color="primary" />
            </div>
          ) : (
            <div className={classes.content} style={{ padding: 10 }}>
              {data?.length > 0 ? (
                <table width="100%" cellPadding="5">
                  <tbody>
                    {data.map((el, key) => (
                      <>
                        <tr>
                          <td width="30%">
                            <Typography variant="body1">{el.key}:</Typography>
                          </td>
                          <td width="70%">
                            {isArray(el.value) ? (
                              el.value.map((item) => (
                                <Chip color={el.color} text={item} />
                              ))
                            ) : (
                              <Chip color={el.color} text={el.value} />
                            )}
                          </td>
                        </tr>
                        {data[key + 1] && data[key + 1]?.color !== el.color && (
                          <tr>
                            <td colspan="2">
                              <Divider />
                            </td>
                          </tr>
                        )}
                      </>
                    ))}
                  </tbody>
                </table>
              ) : (
                <>
                  <EmptyState text={t('commons.searchResultEmpty')}>
                    <InfoIcon />
                  </EmptyState>
                  {renderRetryButton(usability, chatId, skillId)}
                </>
              )}
            </div>
          )}
        </Collapse>
      </>
    )
  }
  const renderResumo = (data) => {
    if (data) {
      switch (Object.prototype.toString.call(data)) {
        case '[object Number]':
        case '[object String]':
          return (
            <table width="100%" cellPadding="10">
              <tbody>
                <tr>
                  <td colSpan="2">
                    <Typography variant="body1">
                      <EscapeDrag>{data}</EscapeDrag>
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </table>
          )
        case '[object Object]':
          return (
            <table width="100%" cellPadding="10">
              <tbody>
                {Object.entries(data).map((e) => {
                  if (typeof e[1] === 'boolean') {
                    e[1] = JSON.stringify(e[1])
                  }
                  return (
                    <tr>
                      <td colSpan="2">
                        <Typography variant="body1">
                          <EscapeDrag>
                            {typeof e[1] === 'number' ||
                            typeof e[1] === 'string'
                              ? e[0]
                              : t('commons.errors.invalidType')}
                          </EscapeDrag>
                        </Typography>
                      </td>
                      <td colSpan="2">
                        <Typography variant="body1">
                          <EscapeDrag>
                            {typeof e[1] === 'number' ||
                            typeof e[1] === 'string'
                              ? e[1]
                              : t('commons.errors.invalidType')}
                          </EscapeDrag>
                        </Typography>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )
        default:
          return (
            <table width="100%" cellPadding="10">
              <tbody>
                <tr>
                  <td colSpan="2">
                    <Typography variant="body1">
                      <EscapeDrag>{t('commons.errors.invalidType')}</EscapeDrag>
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </table>
          )
      }
    } else if(commentary.length === 0){
      return (
        <>
          <EmptyState text={t('commons.searchResultEmpty')}>
            <InfoIcon />
          </EmptyState>
        </>
      )
    }
  }

  const renderSummaryTransfers = ()=>{
    return(
      <div>
        <div 
          onClick={summaryTransfersToggle}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >                
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'start',
            }}
          >
            {summaryTransfers ? (
              <DownIcon
                style={{ color: theme.palette.primary.main }}
              />                        
            ) : (
              <ChevronRight
                style={{ color: theme.palette.primary.main }}
              />                 
            )}
          </div>
          <Typography variant="body" style={{color: theme.palette.text.primary}}>{t('commons.transferSummary')}</Typography>
        </div>
        <Collapse in={summaryTransfers} timeout="auto" unmountOnExit>
          {
            summaryTransfersLoading ? (
              <>
                <div className={classes.loadingSection}>
                  <CircularProgress size={25} color="primary" />
                </div>
              </>
            ) : commentary?.length > 0 ? commentary?.map((ele)=>(
              <div 
                key={`commentary-${ele?.id}-${ele?.created_at}`} 
                style={{marginTop: 20, marginBottom: 20, paddingLeft: 15, paddingRight: 15}}>

                <Grid style={{marginBottom: 20}}>
                  <Grid item>
                    <Typography style={{color: theme.palette.text.primary}} variant="body">{t('commons.transferredIn')} <span>{formateDateTime(ele?.created_at)}</span></Typography>
                  </Grid>
                  <Grid item>
                    <Typography style={{color: theme.palette.text.primary}} variant="body">{t('commons.from')}: <span>{ele?.skill_name_from}</span></Typography>
                  </Grid>
                  <Grid item>
                    <Typography style={{color: theme.palette.text.primary}} variant="body">{t('commons.to')}: <span>{ele?.skill_name_to}</span></Typography>
                  </Grid>
                </Grid>

                <TextField 
                  id="reasonForTransfer" 
                  label={t('commons.reasonForTransfer')}
                  onChange={()=>{}}
                  value={ele.content}
                  fullWidth                       
                  variant="outlined"                      
                  multiline/>
              </div>
            )) : null
          }
        </Collapse>
      </div>
    )
  };

  const renderAbstract = (chatId) => {
    const extraInfo = generalInformation?.conversations?.[chatId]?.extraInfo
    
    let data = null

    if (extraInfo?.resumo) {  
      data = extraInfo?.resumo
    }
    
    if (typeof extraInfo?.Resumo === 'object') {
      data = extraInfo?.Resumo
    }  

    if (typeof extraInfo?.Resumo === 'string') {        
      data = extraInfo;
    }  

    const chatInfo = generalInformation?.conversations?.[chatId]?.chatInfo   
    if (chatInfo?.skillName) {
      data = {
        [t('faqs.skill')]: chatInfo.skillName,
        ...data,
      }
    }

    return (
      <>
        <div className={classes.menuBar} onClick={() => handleCollapse(2)}>
          <Typography variant="body1">{t('commons.abstract')}</Typography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {expanded[2] ? (
              <UpIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            ) : (
              <DownIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            )}
          </div>
        </div>
        <Collapse in={expanded[2]} timeout="auto" unmountOnExit>
          {generalInformation?.status?.get_general_info?.loading ? (
            <div className={classes.loadingSection}>
              <CircularProgress size={25} color="primary" />
            </div>
          ) : (
              <div className={classes.content} style={{ padding: 10 }}>                 

              {renderSummaryTransfers()}

              {renderResumo(data, commentary)}
            </div>
          )}
        </Collapse>
      </>
    )
  }

  const renderDemand = (chatId, usability) => {
    if (
      !(
        widgets?.status?.get_widgets?.loading ||
        widgets?.status?.get_widget?.loading
      ) &&
      !usability
    ) {
      if (props?.ticket) {
        return (
          <>
            <div className={classes.menuBar} onClick={() => handleCollapse(3)}>
              <Typography variant="body1">
                {t('commons.registerDemand')}
              </Typography>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                {expanded[3] ? (
                  <UpIcon
                    style={{
                      marginLeft: 10,
                      color: theme.palette.primary.main,
                    }}
                  />
                ) : (
                  <DownIcon
                    style={{
                      marginLeft: 10,
                      color: theme.palette.primary.main,
                    }}
                  />
                )}
              </div>
            </div>
            <Collapse in={expanded[3]} timeout="auto" unmountOnExit>
              {tabs?.status?.get_tabs?.loading && (
                <div className={classes.loadingSection}>
                  <CircularProgress size={25} color="primary" />
                </div>
              )}
              <Demand
                chatId={chatId}
                isHistoryData={props?.isHistoryData}
                ticket={props?.ticket}
              />
            </Collapse>
          </>
        )
      }
      return (
        <>
          <div className={classes.menuBar} onClick={() => handleCollapse(3)}>
            <Typography variant="body1">
              {t('commons.registerDemand')}
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {expanded[3] ? (
                <UpIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              ) : (
                <DownIcon
                  style={{ marginLeft: 10, color: theme.palette.primary.main }}
                />
              )}
            </div>
          </div>
          <Collapse in={expanded[3]} timeout="auto" unmountOnExit>
            {tabs?.status?.get_tabs?.loading && (
              <div className={classes.loadingSection}>
                <CircularProgress size={25} color="primary" />
              </div>
            )}
            <Demand chatId={chatId} isHistoryData={props?.isHistoryData} />
          </Collapse>
        </>
      )
    }
  }

  const renderUsabilityButton = (usability) => {
    const isClosed =
      conversation.status === 'closed' || conversation.status === 'pos-chat'

    if (objLength(usability?.data) > 0) {
      return (
        <div className={classes.usabilityMask}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            border="rounded"
            onClick={() => handleUsabilityClick(usability)}
            disabled={!relation?.name || isClosed}
          >
            {!isClosed
              ? `${t('commons.openUsability')} (${usability.data.scenario})`
              : `(${usability?.data?.scenario})`}
          </Button>
        </div>
      )
    }
  }

  const renderContent = () => {
    const chatId = props?.chatId
      ? props.chatId
      : !props?.isHistoryData
      ? activeConversation
      : null

    if (chatId) {
      let usabilityScope

      const availableWidgets = widgets?.conversations?.[chatId]

      // TODO: get this name through API when CRUD is implemented
      const usability = availableWidgets?.find(
        (el) => el.name === 'Usabilidade'
      )

      usabilityScope = usability

      if (props?.ticket) {
        return (
          <>
            {!props?.isEngagementHistory &&
              renderDemand(chatId, usabilityScope)}
          </>
        )
      }

      return (
        <>
          {renderAbstract(chatId)}
          {renderContactInfo(chatId)}
          {renderServiceSummary(usability, chatId)}
          {!props?.isEngagementHistory && renderDemand(chatId, usability)}
          {renderUsabilityButton(usability)}
          {renderTabList(chatId)}
        </>
      )
    }
  }

  const renderTabList = (chatId) => {
    return (
      <>
        <div className={classes.menuBar} onClick={() => handleCollapse(4)}>
          <Typography variant="body1">
            {t('commons.tabulationsList')}
          </Typography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {expanded[4] ? (
              <UpIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            ) : (
              <DownIcon
                style={{ marginLeft: 10, color: theme.palette.primary.main }}
              />
            )}
          </div>
        </div>
        <Collapse in={expanded[4]} timeout="auto" unmountOnExit>
          <TabList chatId={chatId} />
        </Collapse>
      </>
    )
  }

  useEffect(() => {
    ;(async () => {
      const chatId = props?.chatId
        ? props.chatId
        : !props?.isHistoryData
        ? activeConversation
        : null

      const aux =
        history?.conversations?.[consumer?.id]?.[chatId]?.skillId ??
        conversations?.conversations?.[chatId]?.skillId

      setSkillId(aux)

      if (chatId) {
        if (!generalInformation?.conversations?.[chatId]) {
          getChatInfo(chatId, dispatch)
        }
        await callWidgets(chatId, aux)
        handleRelationSelect()
      }
    })()
  }, [props?.chatId, activeConversation])

  return (
    <>
      <div className={classes.root}>{renderContent()}</div>
      {dialogEditName && (
        <DialogEditName
          dialogOpen={dialogEditName}
          setDialogOpen={setDialogEditName}
        />
      )}
    </>
  )
}

export default memo(HistoryData)
